// frontend/src/utils/imageUrl.js
// Зургийн URL-г зөв формат руу хөрвүүлэх

const API_BASE = import.meta.env.VITE_API_URL?.replace('/api/v1', '') || '';

export const getImageUrl = (path) => {
  if (!path) return null;
  
  // Хэрэв аль хэдийн full URL байвал шууд буцаах
  if (path.startsWith('http://') || path.startsWith('https://')) {
    // localhost URL-г production URL болгох
    if (path.includes('localhost:5000')) {
      return path.replace('http://localhost:5000', API_BASE);
    }
    return path;
  }
  
  // Relative path бол API_BASE нэмэх
  return `${API_BASE}${path}`;
};

export default getImageUrl;